import { TemplatePage } from './types';

const blackFridayDayPage: TemplatePage = {
  header: {
    color: '#FEDA8C',
    icon: 'images/video-templates/black-friday.jpg',
    title: 'Black Friday & Cyber Monday Video Templates Collection',
    title_meta: '50+ Free Black Friday & Cyber Monday Video Templates',
    description_meta:
      'Draw in more customers and sales with 50+ editable Black Friday & Cyber Monday video templates.',
    description:
      'Draw in more customers and sales with these editable Black Friday & Cyber Monday video templates. Effectively promote your sales and special deals with compelling marketing videos.'
  },
  footer: {
    category: 'Black Friday & Cyber Monday',
    description:
      'With Wave.video’s collection of Black Friday & Cyber Monday video templates, you will be able to easily create effective marketing videos for your social media, website, blog, or email newsletter. All templates are easy and free to edit to achieve your business goals.'
  },
  content: [
    {
      type: 'templates',
      title: 'Black Friday & Cyber Monday',
      search: {
        category: '/Holidays & Occasions/Black Friday & Cyber Monday'
      }
    },
    {
      type: 'stocks',
      title: 'Black Friday & Cyber Monday',
      search: {
        name: 'Black Friday & Cyber Monday'
      }
    },
    { type: 'calendar' }
  ]
};

export default blackFridayDayPage;
